import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlanoContasEmpresaEditarComponent } from './plano-contas-empresa-editar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: PlanoContasEmpresaEditarComponent}
  ])],
  exports: [RouterModule]
})
export class PlanoContasEmpresaEditarRoutingModule { }
